import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BasicInput, DatePickerField, BaasicFieldDropdown, BaasicFormControls, BaasicButton } from "core/components";
import { Content } from "core/layouts";

const TrackingCaseDocumentEditModalTemplate = function({ trackingCaseDocumentEditModalStore, componentProps, t }) {
    const {
        contentLoading,
        form,
        documentTypeStore,
        documentFormStore
    } = trackingCaseDocumentEditModalStore;

    return (
        <div>
            <form onSubmit={form.onSubmit}>
                <div className="modal__header">
                    <h2 className="modal__header__title">
                        {componentProps.modalParams.data.isEdit ? 'Edit' : 'Add'} Tracking Case Document
                    </h2>
                </div>
                <div className="modal__body">
                    <Content loading={contentLoading}>
                        <div className="row">
                            <div className="form__group col col-sml-6">
                                <BaasicFieldDropdown field={form.$('documentTypeId')} store={documentTypeStore} />
                            </div>
                            <div className="form__group col col-sml-6">
                                <BaasicFieldDropdown field={form.$('documentFormId')} store={documentFormStore} />
                            </div>
                            <div className="form__group col col-sml-6">
                                <DatePickerField field={form.$('validFrom')} />
                            </div>
                            <div className="form__group col col-sml-6">
                                <DatePickerField field={form.$('validTo')} />
                            </div>
                        </div>
                        <div className="form__group">
                            <BasicInput field={form.$('name')} />
                        </div>
                        <div className="form__group">
                            <BasicInput field={form.$('description')} />
                        </div>
                    </Content>
                </div>

                <div className="modal__footer">
                    <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} className='btn btn--med btn--primary'/>
                    <BaasicButton
                        className='btn btn--med btn--light'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={() => componentProps.modalParams.close()}
                    />
                </div>
            </form>
        </div>
    );
};

TrackingCaseDocumentEditModalTemplate.propTypes = {
    trackingCaseDocumentEditModalStore: PropTypes.object.isRequired,
    componentProps: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(TrackingCaseDocumentEditModalTemplate);